import React, {PropTypes} from 'react';
import {Link} from 'react-router';
import * as paths from '../../../constants/pathConstants';
import * as caseDataConstants from '../../../constants/caseDataConstants';
import Button from '../../common/Button';

const CaseDataTableRow = ({caseData, establishment_id, evenRow, onDelete})=> {
  const onDeleteClick = () => {
    onDelete(caseData);
  };
	return (
		<tr className={evenRow ? "even-row" : ""}>
      <td>
        <Link to={`${paths.pathToEstablishmentsDashboardPage}/${establishment_id}${paths.pathToCaseDataFormPageEdit}/${caseData.id}`}>
         Edit
        </Link>
      </td>
      <td>
        {caseData.case_number}
      </td>
      <td>
        {caseData.job_title}
      </td>
      <td className="non-mobile">
        {caseData.date_of_incident}
      </td>
      <td className="non-mobile">
        {caseData.incident_location}
      </td>
      <td className="non-mobile">
        {caseDataConstants.MOST_SERIOUS_OUTCOME[caseData.case_classification]}
      </td>
      <td className="non-mobile">
        {caseData.dafw_days}
      </td>
      <td className="non-mobile">
        {caseData.djtr_days}
      </td>
      <td className="non-mobile">
        {caseDataConstants.INJURY_TYPE[caseData.injury_illness_type]}
      </td>
      <td>
        <Button
          onClick={onDeleteClick}
          value="Delete"
          className="btn btn-delete"/>
      </td>
    </tr>
	);
};

CaseDataTableRow.propTypes ={
  caseData: PropTypes.object.isRequired,
  establishment_id: PropTypes.number,
  //isSelected: PropTypes.bool.isRequired,
  evenRow: PropTypes.number,
  onDelete: PropTypes.func.isRequired
};

export default CaseDataTableRow;



/** WEBPACK FOOTER **
 ** ./src/components/caseData/caseDataTable/CaseDataTableRow.js
 **/